import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";

interface RoleChangeConfirm {
  userId: string;
  email: string;
  newRole: string;
}

interface AccessToggleConfirm {
  userId: string;
  email: string;
  currentStatus: boolean;
}

interface ConfirmationDialogsProps {
  roleChangeConfirm: RoleChangeConfirm | null;
  accessToggleConfirm: AccessToggleConfirm | null;
  onRoleChangeConfirm: () => void;
  onAccessToggleConfirm: () => void;
  onRoleChangeCancel: () => void;
  onAccessToggleCancel: () => void;
  isUpdating: boolean;
}

export function ConfirmationDialogs({
  roleChangeConfirm,
  accessToggleConfirm,
  onRoleChangeConfirm,
  onAccessToggleConfirm,
  onRoleChangeCancel,
  onAccessToggleCancel,
  isUpdating
}: ConfirmationDialogsProps) {
  return (
    <>
      <AlertDialog open={!!roleChangeConfirm} onOpenChange={onRoleChangeCancel}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>Change User Role?</AlertDialogTitle>
            <AlertDialogDescription>
              Are you sure you want to change the role of <strong>{roleChangeConfirm?.email}</strong> to <strong>{roleChangeConfirm?.newRole}</strong>?
              {roleChangeConfirm?.newRole === 'admin' && (
                <span className="block mt-2 text-amber-600">This will grant admin privileges to this user.</span>
              )}
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel>Cancel</AlertDialogCancel>
            <AlertDialogAction onClick={onRoleChangeConfirm} disabled={isUpdating}>
              {isUpdating ? 'Updating...' : 'Confirm'}
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>

      <AlertDialog open={!!accessToggleConfirm} onOpenChange={onAccessToggleCancel}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>{accessToggleConfirm?.currentStatus ? 'Disable' : 'Enable'} User Access?</AlertDialogTitle>
            <AlertDialogDescription>
              Are you sure you want to {accessToggleConfirm?.currentStatus ? 'disable' : 'enable'} ChefAiQ access for <strong>{accessToggleConfirm?.email}</strong>?
              {accessToggleConfirm?.currentStatus && (
                <span className="block mt-2 text-red-600">This user will not be able to access the ChefAiQ application.</span>
              )}
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel>Cancel</AlertDialogCancel>
            <AlertDialogAction onClick={onAccessToggleConfirm} disabled={isUpdating}>
              {isUpdating ? 'Updating...' : 'Confirm'}
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
}
